"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const CategoryHeader_1 = __importDefault(require("./CategoryHeader"));
exports.default = CategoryHeader_1.default;
